export const DATAGRIDCONSTANTS = {
    ICON_COLUMN_DEFAULT_WIDTH: 16,
    GRID_HEIGHT: 470,
    LOADING_PANEL_WIDTH_HEIGHT: 20,
    header: {
        IconColumn: 60,
        InquiryColumn: 137,
        UserColumn: 62,
        UsernameColumn: 149,
        EnteredColumn: 88,
        TimeColumn: 49,
        DeliveryColumn: 242,
        NotesColumn: 444,
        ButtonsColumn: 70,
    }
};

export const columns = [
    {
        dataField: 'ParkedSaleId',
        caption: 'Inquiry',
        width: DATAGRIDCONSTANTS.header.InquiryColumn,
        fixed: true,
        allowResizing: false,
    },
    {
        dataField: 'User',
        caption: 'User ID',
        width: DATAGRIDCONSTANTS.header.UserColumn,
        allowSorting: false,
        allowEditing: false,
        allowResizing: true,
    },
    {
        dataField: 'Username',
        caption: 'User name',
        width: DATAGRIDCONSTANTS.header.UsernameColumn,
        allowResizing: true,
    },
    {
        dataField: 'Entered',
        caption: 'Entered',
        width: DATAGRIDCONSTANTS.header.EnteredColumn,
        allowResizing: false,
    },
    {
        dataField: 'TimeDisplay',
        caption: 'Time',
        width: DATAGRIDCONSTANTS.header.TimeColumn,
        allowResizing: true,
    },
    {
        dataField: 'CustomerName',
        caption: 'Delivery name',
        width: DATAGRIDCONSTANTS.header.DeliveryColumn,
        allowResizing: true,
    },
    {
        dataField: 'Note',
        caption: 'Notes',
        width: DATAGRIDCONSTANTS.header.NotesColumn,
        allowResizing: true,
    },
];
